const investmentTypes = {
    traditional: 'traditional',
    robo: 'robo',
    gbi: 'gbi',
    roboRejected: 'robo-rejected',
    gbiRejected: 'gbi-rejected',
    creditCard: 'credit-card',
    loan: 'loan',
    loanNoVedacon: 'loan-no-vedacon',
};

const accountTypes = {
    cuentaPropia: '01',
    asalariado: '02',
    rentista: '03',
    pensionista: '04',
    sinActividad: '05',
};

const noActivityTypes = {
    homework: 'X200A',
    unemployed: 'X300A',
    student: 'X300B',
};

export default {
    TRADITIONAL: investmentTypes.traditional,
    ROBO: investmentTypes.robo,
    GBI: investmentTypes.gbi,
    ROBO_REJECTED: investmentTypes.roboRejected,
    GBI_REJECTED: investmentTypes.gbiRejected,
    CREDIT_CARD: investmentTypes.creditCard,
    LOAN: investmentTypes.loan,
    LOAN_NO_VEDACON: investmentTypes.loanNoVedacon,
    OWN_ACCOUNT: accountTypes.cuentaPropia,
    SALARIED: accountTypes.asalariado,
    RENTIER: accountTypes.rentista,
    PENSIONER: accountTypes.pensionista,
    NO_ACTIVITY: accountTypes.sinActividad,
    HOMEWORK: noActivityTypes.homework,
    UNEMPLOYED: noActivityTypes.unemployed,
    STUDENT: noActivityTypes.student,
};
